import http from "@/http"

const api = {
  async getStockDetails(locationId) {
    return await http.get(`/stockDetails?locationId=${locationId}`)
  }
}

export default api
